// removed by extract-text-webpack-plugin
module.exports = {"root":"TemplateApplicationSubHeader__root___2HfG6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateApplication/TemplateApplicationSubHeader/TemplateApplicationSubHeader.scss
// module id = 1035
// module chunks = 0